
































import {
  computed,
  defineComponent,
  nextTick,
  ref,
  toRefs,
  useFetch
} from '@nuxtjs/composition-api'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import KeyFeaturesInColumns from '~/components/car/classifieds/view/partials/key-features/KeyFeaturesInColumns.vue'
import { useNamespacedStore } from '~/compositions/store'
import { TradesState, TRADES_NS } from '~/store/modules/shared/trades/state'
import CCategorySelect from '~/components/shared/configurable/category/select/CCategorySelect.vue'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import TradesList from '~/components/car/trades/TradesList.vue'
import { fetchTradableClassifieds } from '~/store/modules/shared/trades/actions-types'
import TradableClassified from '~/components/car/trades/TradableClassified.vue'

export default defineComponent({
  components: {
    TradableClassified,
    TradesList,
    CExpandableContent,
    KeyFeaturesInColumns,
    CCategorySelect,
    CAvatar
  },
  props: {
    classifiedId: {
      type: String,
      required: false,
      default: ''
    },
    inIndex: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const { classifiedId, inIndex } = toRefs(props)
    const { state, dispatch } = useNamespacedStore<TradesState>(TRADES_NS)
    const isLoading = ref(true)
    const tradableClassifeids = computed(() => {
      if (state.tradableClassifieds) {
        if (classifiedId.value) {
          return state.tradableClassifieds.filter(
            c => c.id.toString() !== classifiedId.value.toString()
          )
        }
        return state.tradableClassifieds
      }

      return []
    })

    useFetch(async () => {
      if (!inIndex.value) {
        isLoading.value = true
        await dispatch(fetchTradableClassifieds)
        await nextTick()
        isLoading.value = false
      } else {
        // fetching is done in index
        isLoading.value = false
      }
    })

    return {
      isLoading,
      tradableClassifeids
    }
  }
})
